<template>
  <div class="sheet-panel user-persona report-persona">
    <span class="counter" :title="people" v-tippy="{ theme: 'navy' }"
      >x{{ personaData.length }}</span
    >
    <div class="sheet-content">
      <div class="persona-top">
        <img
          :src="'https://cdn.traitstack.com/static/' + personas[persona].image"
          class="persona-image"
        />
        <div class="content">
          <div class="h4 blue">
            {{ personas[persona].title }}
          </div>
          <div class="tag-list">
            <div
              class="tag"
              v-bind:key="tag"
              v-for="tag in personas[persona].tags"
            >{{ tag }}</div>
          </div>
        </div>
      </div>

      <p>
        {{ personas[persona].description }}
      </p>
    </div>
  </div>
</template>
<script>
import { personas, reporting } from "@/assets/static.js";
export default {
  props: {
    persona: String,
    personaData: Array,
  },
  computed: {
    people() {
      let peopleString = "";
      this.personaData.forEach(element => {
        peopleString += element.firstName + " " + element.lastName + " ";
      });
      return peopleString;
    }
  },
  data() {
    return {
      personas: personas,
      reporting: reporting,
    };
  },
  methods: {},
};
</script>
